var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u53CD\u9988") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u6587\\u6863\\u6846\\u67B6\\u4F18\\u5316",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6587\\u6863_PC_1440",
    transform: "translate(-1403.000000, -836.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5206\\u7EC4-64",
    transform: "translate(1390.000000, 764.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u53CD\\u9988",
    transform: "translate(13.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u63D0pr",
    transform: "translate(0.000000, 3.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-41",
    x: 1,
    y: 1,
    width: 22,
    height: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 2,
    x2: 12.6093595,
    y2: 11.4985669,
    id: "Line-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.3906405,
    y1: 2,
    x2: 23,
    y2: 11.4985669,
    id: "Line-4",
    transform: "translate(17.195320, 6.749283) scale(-1, 1) translate(-17.195320, -6.749283) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.7e679f6375eba60b46541b79714390c6.svg";
export { ForwardRef as ReactComponent };